import React from 'react';
import { NavLink } from 'react-router-dom';
import { PushIcon } from '../Icons';

const DocComponent = props => {
  return (
    <li className="nav-item">
      <NavLink
        onClick={props.onClick}
        to={props.link}
        activeClassName="active"
        className="vertical-nav-hover nav-link text-dark rounded-lg text-decoration-none"
      >
        <PushIcon fill="#202020" />
        Push Notification
      </NavLink>
    </li>
  );
};
export default DocComponent;
